import React from 'react';
import { WifiOff } from 'lucide-react';

const OfflineIndicator = () => {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      backgroundColor: '#fef3c7',
      color: '#92400e',
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: '500',
      border: '1px solid #fcd34d'
    }}>
      <WifiOff size={14} />
      <span>Offline</span>
    </div>
  );
};

export default OfflineIndicator;
